import Icon from '@/utils/Icon';
import styled from 'styled-components';
import theme from '@/utils/Theme';

const Infobox = ({ status, children, size, svgSize }) => {
  let iconToRender, colorToRender;
  switch (status) {
    case 'success':
      iconToRender = 'check-circle';
      colorToRender = 'green';
      break;
    case 'error':
      iconToRender = 'alert-circle-exc';
      colorToRender = 'orange';
      break;
    default:
      iconToRender = 'info';
      colorToRender = 'blue';
      break;
  }

  return (
    <InfoBoxWrapper $bordercolor={colorToRender}>
      <InfoboxInner>
        <Icon icon={iconToRender} size={svgSize || 32} color={theme.colors[colorToRender]} />
        <p
          style={{
            fontSize: size || '2.4rem',
            color: theme.colors[colorToRender],
          }}>
          <span dangerouslySetInnerHTML={{ __html: children }} />
        </p>
      </InfoboxInner>
    </InfoBoxWrapper>
  );
};

export default Infobox;

const InfoBoxWrapper = styled.div.attrs({
  className: 'InfoBoxWrapper',
})`
  max-width: 1400px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0;
  width: 100%;
  padding: 20px;
  background: ${(props) => props.theme.colors.white};
  border-radius: 4px;
  border: 1px solid ${(props) => props.theme.colors[props.$bordercolor]};
  box-shadow: 12px 12px 12px ${(props) => props.theme.colors.blue};
`;

const InfoboxInner = styled.div.attrs({
  className: 'InfoboxInner',
})`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  > p {
    margin: 0 !important;
    line-height: 1.4 !important;
    text-wrap: auto;
  }
  > svg {
    flex: 0 0 auto;
  }
`;
